/**
 * GENERATED by tools/input/gen-controller-data.mjs from research/data/controller.json — do not edit.
 * view_input_N.graph: common_mp.ff aim_assist/*.graph [CTL §4.3]; rumble/*: patch_mp/code_post_gfx_mp/common_mp [CTL §7].
 */
export type Knots = readonly (readonly [number, number])[];

/** aim_assist/view_input_0..3.graph (x = stick deflection after deadzone, y = gain). Default index 3. */
export const VIEW_INPUT_GRAPHS: readonly Knots[] = [[[0,0],[0.1218,0.0171],[0.1972,0.0295],[0.2612,0.0451],[0.3244,0.0644],[0.3872,0.0897],[0.4543,0.1281],[0.5149,0.1729],[0.5723,0.2203],[0.6263,0.2771],[0.6771,0.3483],[0.7288,0.4296],[0.7781,0.5157],[0.8387,0.6301],[1,1]],[[0,0],[0.1323,0.0235],[0.2102,0.0469],[0.2939,0.0778],[0.3741,0.117],[0.4555,0.1724],[0.5401,0.24],[0.6118,0.3149],[0.6726,0.4018],[0.7268,0.4906],[0.7797,0.5833],[0.8386,0.6926],[1,1]],[[0,0],[0.1322,0.0396],[0.2338,0.078],[0.3235,0.1267],[0.4022,0.1812],[0.4809,0.2479],[0.5561,0.3254],[0.6205,0.3936],[0.693,0.4771],[0.7819,0.5943],[0.8598,0.7299],[1,1]],[[0,0],[0.1242,0.0423],[0.2238,0.0885],[0.321,0.1553],[0.4118,0.2419],[0.5116,0.3508],[1,1]]];

export interface RumbleDef { broadcast: boolean; duration: number; fadeWithDistance: boolean; range: number; high: string; low: string }
export const RUMBLES: Readonly<Record<string, RumbleDef>> = {
 "assault_fire": {
  "broadcast": false,
  "duration": 0.3,
  "fadeWithDistance": false,
  "range": 1,
  "high": "assault_fire_h.rmb",
  "low": "assault_fire_l.rmb"
 },
 "damage_heavy": {
  "broadcast": false,
  "duration": 0.3,
  "fadeWithDistance": false,
  "range": 1,
  "high": "damage_heavy_h.rmb",
  "low": "damage_heavy_l.rmb"
 },
 "damage_light": {
  "broadcast": false,
  "duration": 0.3,
  "fadeWithDistance": false,
  "range": 1,
  "high": "damage_light_h.rmb",
  "low": "damage_light_l.rmb"
 },
 "defaultweapon_fire": {
  "broadcast": false,
  "duration": 0.5,
  "fadeWithDistance": false,
  "range": 1,
  "high": "defaultweapon_fire_h.rmb",
  "low": "defaultweapon_fire_l.rmb"
 },
 "defaultweapon_melee": {
  "broadcast": false,
  "duration": 0.5,
  "fadeWithDistance": false,
  "range": 1,
  "high": "defaultweapon_melee_h.rmb",
  "low": "defaultweapon_melee_l.rmb"
 },
 "heavygun_fire": {
  "broadcast": false,
  "duration": 0.5,
  "fadeWithDistance": true,
  "range": 1,
  "high": "heavygun_fire_h.rmb",
  "low": "heavygun_fire_l.rmb"
 },
 "lmg_fire": {
  "broadcast": false,
  "duration": 0.3,
  "fadeWithDistance": false,
  "range": 1,
  "high": "lmg_fire_h.rmb",
  "low": "lmg_fire_l.rmb"
 },
 "pistol_fire": {
  "broadcast": false,
  "duration": 0.5,
  "fadeWithDistance": true,
  "range": 1,
  "high": "pistol_fire_h.rmb",
  "low": "pistol_fire_l.rmb"
 },
 "shotgun_fire": {
  "broadcast": false,
  "duration": 0.3,
  "fadeWithDistance": true,
  "range": 1,
  "high": "shotgun_fire_h.rmb",
  "low": "shotgun_fire_l.rmb"
 },
 "smg_fire": {
  "broadcast": false,
  "duration": 0.3,
  "fadeWithDistance": false,
  "range": 1,
  "high": "smg_fire_h.rmb",
  "low": "smg_fire_l.rmb"
 },
 "sniper_fire": {
  "broadcast": false,
  "duration": 0.3,
  "fadeWithDistance": true,
  "range": 1,
  "high": "shotgun_fire_h.rmb",
  "low": "shotgun_fire_l.rmb"
 },
 "artillery_rumble": {
  "broadcast": true,
  "duration": 1,
  "fadeWithDistance": false,
  "range": 800,
  "high": "artillery_rumble_h.rmb",
  "low": "artillery_rumble_l.rmb"
 },
 "buzz_high": {
  "broadcast": false,
  "duration": 0.08,
  "fadeWithDistance": false,
  "range": 1,
  "high": "buzz_high_h.rmb",
  "low": "buzz_high_l.rmb"
 },
 "grenade_rumble": {
  "broadcast": true,
  "duration": 1,
  "fadeWithDistance": false,
  "range": 400,
  "high": "grenade_rumble_h.rmb",
  "low": "grenade_rumble_l.rmb"
 },
 "plane_rumble": {
  "broadcast": false,
  "duration": 15,
  "fadeWithDistance": false,
  "range": 1,
  "high": "plane_rumble_h.rmb",
  "low": "plane_rumble_l.rmb"
 },
 "proximity_grenade": {
  "broadcast": false,
  "duration": 1.5,
  "fadeWithDistance": false,
  "range": 1,
  "high": "proximity_grenade_h.rmb",
  "low": "proximity_grenade_l.rmb"
 },
 "pullout_small": {
  "broadcast": false,
  "duration": 0.25,
  "fadeWithDistance": true,
  "range": 1,
  "high": "reload_small_h.rmb",
  "low": "reload_small_l.rmb"
 },
 "rcbomb_engine_stutter": {
  "broadcast": false,
  "duration": 0.3,
  "fadeWithDistance": false,
  "range": 1,
  "high": "rcbomb_engine_stutter_h.rmb",
  "low": "rcbomb_engine_stutter_l.rmb"
 },
 "rcbomb_slide": {
  "broadcast": false,
  "duration": 0.3,
  "fadeWithDistance": false,
  "range": 1,
  "high": "rcbomb_slide_h.rmb",
  "low": "rcbomb_slide_l.rmb"
 },
 "reload_clipin": {
  "broadcast": false,
  "duration": 0.3,
  "fadeWithDistance": true,
  "range": 1,
  "high": "reload_small_h.rmb",
  "low": "reload_small_l.rmb"
 },
 "reload_clipout": {
  "broadcast": false,
  "duration": 0.3,
  "fadeWithDistance": true,
  "range": 1,
  "high": "reload_small_h.rmb",
  "low": "reload_small_l.rmb"
 },
 "reload_large": {
  "broadcast": false,
  "duration": 0.3,
  "fadeWithDistance": true,
  "range": 1,
  "high": "reload_large_h.rmb",
  "low": "reload_large_l.rmb"
 },
 "reload_medium": {
  "broadcast": false,
  "duration": 0.3,
  "fadeWithDistance": true,
  "range": 1,
  "high": "reload_medium_h.rmb",
  "low": "reload_medium_l.rmb"
 },
 "reload_rechamber": {
  "broadcast": false,
  "duration": 0.3,
  "fadeWithDistance": true,
  "range": 1,
  "high": "reload_small_h.rmb",
  "low": "reload_small_l.rmb"
 },
 "reload_small": {
  "broadcast": false,
  "duration": 0.3,
  "fadeWithDistance": true,
  "range": 1,
  "high": "reload_small_h.rmb",
  "low": "reload_small_l.rmb"
 },
 "rolling_thunder_rumble": {
  "broadcast": false,
  "duration": 15,
  "fadeWithDistance": false,
  "range": 1,
  "high": "rolling_thunder_rumble_h.rmb",
  "low": "rolling_thunder_rumble_l.rmb"
 },
 "stinger_lock_rumble": {
  "broadcast": false,
  "duration": 0.1,
  "fadeWithDistance": false,
  "range": 1,
  "high": "damage_light_h.rmb",
  "low": "damage_light_l.rmb"
 },
 "tank_damage_heavy_mp": {
  "broadcast": false,
  "duration": 1,
  "fadeWithDistance": false,
  "range": 500,
  "high": "tank_damage_heavy_h.rmb",
  "low": "tank_damage_heavy_l.rmb"
 },
 "tank_damage_light_mp": {
  "broadcast": false,
  "duration": 1,
  "fadeWithDistance": false,
  "range": 500,
  "high": "tank_damage_light_h.rmb",
  "low": "tank_damage_light_l.rmb"
 },
 "tank_damaged_rumble_mp": {
  "broadcast": true,
  "duration": 1,
  "fadeWithDistance": false,
  "range": 500,
  "high": "tank_damaged_rumble_h.rmb",
  "low": "tank_damaged_rumble_l.rmb"
 },
 "tank_rumble": {
  "broadcast": false,
  "duration": 1,
  "fadeWithDistance": false,
  "range": 750,
  "high": "tank_rumble_h.rmb",
  "low": "tank_rumble_l.rmb"
 },
 "tank_rumble_mp": {
  "broadcast": true,
  "duration": 1,
  "fadeWithDistance": false,
  "range": 500,
  "high": "tank_rumble_h.rmb",
  "low": "tank_rumble_l.rmb"
 },
 "dtp_rumble": {
  "broadcast": false,
  "duration": 1,
  "fadeWithDistance": true,
  "range": 1,
  "high": "artillery_rumble_h.rmb",
  "low": "artillery_rumble_l.rmb"
 },
 "slide_rumble": {
  "broadcast": false,
  "duration": 100,
  "fadeWithDistance": true,
  "range": 1,
  "high": "artillery_rumble_l.rmb",
  "low": "artillery_rumble_l.rmb"
 },
 "riotshield_impact": {
  "broadcast": false,
  "duration": 0.5,
  "fadeWithDistance": false,
  "range": 1,
  "high": "riotshield_impact_h.rmb",
  "low": "riotshield_impact_l.rmb"
 },
 "minigun_rumble": {
  "broadcast": true,
  "duration": 0.3,
  "fadeWithDistance": true,
  "range": 750,
  "high": "tank_rumble_h.rmb",
  "low": "tank_rumble_l.rmb"
 },
 "tank_fire_mp": {
  "broadcast": false,
  "duration": 0.5,
  "fadeWithDistance": false,
  "range": 500,
  "high": "tank_fire_h.rmb",
  "low": "tank_fire_l.rmb"
 }
};

/** *.rmb graphs: (t 0..1 over duration, intensity 0..1). */
export const RUMBLE_GRAPHS: Readonly<Record<string, Knots>> = {"assault_fire_h.rmb":[[0,0.61],[0.1303,0.58062],[0.2821,0.4148],[0.3042,0.254],[0.3213,0.109],[1,0]],"assault_fire_l.rmb":[[0,0.67],[0.2565,0.6003],[0.3247,0.5],[1,0]],"damage_heavy_h.rmb":[[0,0.5],[0.105,0.3],[1,0]],"damage_heavy_l.rmb":[[0,1],[0.125,1],[0.43,0],[1,0]],"damage_light_h.rmb":[[0,0.5],[0.105,0.3],[1,0]],"damage_light_l.rmb":[[0,1],[0.125,1],[0.43,0],[1,0]],"defaultweapon_fire_h.rmb":[[0,0.4701],[0.1342,0.3639],[0.2868,0.2627],[0.4736,0.1698],[0.6719,0.0826],[0.8317,0.0307],[1,0]],"defaultweapon_fire_l.rmb":[[0,1],[0.1866,1],[0.2241,0],[1,0]],"defaultweapon_melee_h.rmb":[[0,1],[0.0571,1],[0.1701,0.3556],[0.3075,0],[1,0.0001]],"defaultweapon_melee_l.rmb":[[0,1],[0.0746,1],[0.1603,0],[1,0]],"heavygun_fire_h.rmb":[[0,0.4109],[0.1192,0.3717],[0.2806,0.2431],[0.4579,0.1533],[0.6595,0.0449],[0.8328,0.0152],[1,0]],"heavygun_fire_l.rmb":[[0,1],[0.32,1],[0.325,0],[1,0]],"lmg_fire_h.rmb":[[0,0.81],[0.1303,0.7562],[0.2521,0.7048],[0.3042,0.604],[0.3613,0.359],[1,0]],"lmg_fire_l.rmb":[[0,0.82],[0.2565,0.7503],[0.3647,0.65],[1,0]],"pistol_fire_h.rmb":[[0,0.1711],[0.2317,0.0917],[0.6083,0.0215],[1,0.0018]],"pistol_fire_l.rmb":[[0,0.6395],[0.4607,0.6125],[0.4801,0],[1,0]],"shotgun_fire_h.rmb":[[0,1],[0.2265,0.9995],[0.6077,0.9275],[1,0]],"shotgun_fire_l.rmb":[[0,1],[0.3851,1],[0.5701,0.92],[1,0]],"smg_fire_h.rmb":[[0,0.62],[0.1,0.6099],[0.16,0.5888],[0.1861,0.4],[1,0]],"smg_fire_l.rmb":[[0,0.59],[0.1565,0.5303],[0.1847,0.4],[1,0]],"artillery_rumble_h.rmb":[[0,0.74],[0.105,0.54],[1,0]],"artillery_rumble_l.rmb":[[0,1],[0.125,1],[0.43,0.48],[1,0]],"buzz_high_h.rmb":[[0,1],[1,0.0022]],"buzz_high_l.rmb":[[0,0],[1,0]],"grenade_rumble_h.rmb":[[0,0.5],[0.105,0.3],[1,0]],"grenade_rumble_l.rmb":[[0,1],[0.125,1],[0.43,0],[1,0]],"plane_rumble_h.rmb":[[0,0],[1,0]],"plane_rumble_l.rmb":[[0,0],[0.25,0.2],[0.39,0.05],[1,0]],"proximity_grenade_h.rmb":[[0,0.95],[0.55,0.9999],[1,0.9]],"proximity_grenade_l.rmb":[[0,0.9599],[0.3,0.9999],[0.6,0.95],[1,0.9]],"rcbomb_engine_stutter_h.rmb":[[0,0.5],[0.105,0.3],[1,0]],"rcbomb_engine_stutter_l.rmb":[[0,1],[0.485,1],[0.9341,0],[1,0]],"rcbomb_slide_h.rmb":[[0,0.4792],[0.1529,0.0843],[0.3452,0.4292],[1,0]],"rcbomb_slide_l.rmb":[[0,0],[0.1435,0.1175],[0.2994,0],[0.4528,0.1],[0.6205,0],[0.8163,0.0809],[1,0]],"reload_large_h.rmb":[[0,0.5],[0.105,0.3],[1,0]],"reload_large_l.rmb":[[0,1],[0.125,1],[0.43,0],[1,0]],"reload_medium_h.rmb":[[0,0.5],[0.105,0.3],[1,0]],"reload_medium_l.rmb":[[0,1],[0.125,1],[0.43,0],[1,0]],"reload_small_h.rmb":[[0,0.3675],[0.2782,0.204],[1,0]],"reload_small_l.rmb":[[0,0.28],[0.125,0.4],[0.43,0],[1,0]],"rolling_thunder_rumble_h.rmb":[[0,0],[1,0]],"rolling_thunder_rumble_l.rmb":[[0,0],[0.2414,0.1548],[0.4,0.42],[0.6,0.4],[0.6997,0.0271],[1,0]],"stinger_lock_rumble_h.rmb":[[0,1],[1,0]],"stinger_lock_rumble_l.rmb":[[0,0.1],[1,0]],"tank_damage_heavy_h.rmb":[[0,0.5],[0.105,0.3],[1,0]],"tank_damage_heavy_l.rmb":[[0,1],[0.125,1],[0.43,0],[1,0]],"tank_damage_light_h.rmb":[[0,0.5],[0.105,0.3],[1,0]],"tank_damage_light_l.rmb":[[0,1],[0.125,1],[0.43,0],[1,0]],"tank_damaged_rumble_h.rmb":[[0,0.2839],[1,0.1246]],"tank_damaged_rumble_l.rmb":[[0,0.1094],[1,0.1985]],"tank_rumble_h.rmb":[[0,0.1208],[1,0.1246]],"tank_rumble_l.rmb":[[0,0.1095],[1,0.1032]],"riotshield_impact_h.rmb":[[0,0.5],[0.105,0.3],[1,0]],"riotshield_impact_l.rmb":[[0,1],[0.125,1],[0.43,0],[1,0]],"tank_fire_h.rmb":[[0,0.706],[0.1329,0.5108],[0.2909,0.3658],[0.472,0.2646],[0.6727,0.1771],[0.8331,0.0928],[1,0.0416]],"tank_fire_l.rmb":[[0,1],[0.3223,1],[0.4639,0.0002],[1,0]]};
